type HttpStatusMessages = {
  [key: number]: string
}

type SupportedLanguage =
  | 'en'
  | 'es'
  | 'fr'
  | 'de'
  | 'ar'
  | 'ja'
  | 'ko'
  | 'id'
  | 'th'
  | 'nl'
  | 'it'

export const httpStatusMessages: Record<SupportedLanguage, HttpStatusMessages> =
  {
    en: {
      400: "We couldn't process your request. Please check your information and try again.",
      401: 'Please log in to continue with your purchase.',
      402: 'Payment processing failed. Please verify your payment information and try again.',
      403: "You don't have access to this item or page.",
      404: "We couldn't find what you're looking for.",
      405: 'This action is not allowed.',
      408: 'Your request timed out. Please try again.',
      409: 'There was a conflict with your request. Please refresh the page and try again.',
      410: 'This item is no longer available.',
      413: 'The file you uploaded is too large.',
      415: 'This file type is not supported.',
      422: "We couldn't process the information you provided. Please check and try again.",
      429: 'Too many attempts. Please wait a moment and try again.',
      500: 'Something went wrong. Please try again in a few moments.',
      502: 'Our service is temporarily unavailable. Please try again shortly.',
      503: "We're currently performing maintenance. Please check back soon.",
      504: 'Your request took too long to process. Please try again.',
    },
    es: {
      400: 'No pudimos procesar su solicitud. Por favor, verifique su información e intente nuevamente.',
      401: 'Por favor, inicie sesión para continuar con su compra.',
      402: 'El procesamiento del pago falló. Por favor, verifique su información de pago e intente nuevamente.',
      403: 'No tiene acceso a este artículo o página.',
      404: 'No pudimos encontrar lo que está buscando.',
      405: 'Esta acción no está permitida.',
      408: 'Su solicitud expiró. Por favor, intente nuevamente.',
      409: 'Hubo un conflicto con su solicitud. Por favor, actualice la página e intente nuevamente.',
      410: 'Este artículo ya no está disponible.',
      413: 'El archivo que subió es demasiado grande.',
      415: 'Este tipo de archivo no es compatible.',
      422: 'No pudimos procesar la información que proporcionó. Por favor, verifique e intente nuevamente.',
      429: 'Demasiados intentos. Por favor, espere un momento e intente nuevamente.',
      500: 'Algo salió mal. Por favor, intente nuevamente en unos momentos.',
      502: 'Nuestro servicio no está disponible temporalmente. Por favor, intente en breve.',
      503: 'Actualmente estamos realizando mantenimiento. Por favor, regrese pronto.',
      504: 'Su solicitud tardó demasiado en procesarse. Por favor, intente nuevamente.',
    },
    fr: {
      400: "Nous n'avons pas pu traiter votre demande. Veuillez vérifier vos informations et réessayer.",
      401: 'Veuillez vous connecter pour continuer votre achat.',
      402: 'Le traitement du paiement a échoué. Veuillez vérifier vos informations de paiement et réessayer.',
      403: "Vous n'avez pas accès à cet article ou cette page.",
      404: "Nous n'avons pas trouvé ce que vous cherchez.",
      405: "Cette action n'est pas autorisée.",
      408: 'Votre demande a expiré. Veuillez réessayer.',
      409: 'Il y a eu un conflit avec votre demande. Veuillez actualiser la page et réessayer.',
      410: "Cet article n'est plus disponible.",
      413: 'Le fichier que vous avez téléchargé est trop volumineux.',
      415: "Ce type de fichier n'est pas pris en charge.",
      422: "Nous n'avons pas pu traiter les informations que vous avez fournies. Veuillez vérifier et réessayer.",
      429: 'Trop de tentatives. Veuillez patienter un moment et réessayer.',
      500: "Une erreur s'est produite. Veuillez réessayer dans quelques instants.",
      502: 'Notre service est temporairement indisponible. Veuillez réessayer sous peu.',
      503: 'Nous effectuons actuellement une maintenance. Veuillez revenir bientôt.',
      504: 'Votre demande a mis trop de temps à être traitée. Veuillez réessayer.',
    },
    de: {
      400: 'Wir konnten Ihre Anfrage nicht verarbeiten. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.',
      401: 'Bitte melden Sie sich an, um mit Ihrem Kauf fortzufahren.',
      402: 'Zahlungsverarbeitung fehlgeschlagen. Bitte überprüfen Sie Ihre Zahlungsinformationen und versuchen Sie es erneut.',
      403: 'Sie haben keinen Zugriff auf diesen Artikel oder diese Seite.',
      404: 'Wir konnten nicht finden, wonach Sie suchen.',
      405: 'Diese Aktion ist nicht erlaubt.',
      408: 'Ihre Anfrage ist abgelaufen. Bitte versuchen Sie es erneut.',
      409: 'Es gab einen Konflikt mit Ihrer Anfrage. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
      410: 'Dieser Artikel ist nicht mehr verfügbar.',
      413: 'Die hochgeladene Datei ist zu groß.',
      415: 'Dieser Dateityp wird nicht unterstützt.',
      422: 'Wir konnten die von Ihnen bereitgestellten Informationen nicht verarbeiten. Bitte überprüfen Sie sie und versuchen Sie es erneut.',
      429: 'Zu viele Versuche. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
      500: 'Etwas ist schief gelaufen. Bitte versuchen Sie es in wenigen Augenblicken erneut.',
      502: 'Unser Service ist vorübergehend nicht verfügbar. Bitte versuchen Sie es in Kürze erneut.',
      503: 'Wir führen derzeit Wartungsarbeiten durch. Bitte schauen Sie bald wieder vorbei.',
      504: 'Ihre Anfrage hat zu lange gedauert. Bitte versuchen Sie es erneut.',
    },
    ar: {
      400: 'لم نتمكن من معالجة طلبك. يرجى التحقق من معلوماتك والمحاولة مرة أخرى.',
      401: 'يرجى تسجيل الدخول للمتابعة مع عملية الشراء.',
      402: 'فشلت معالجة الدفع. يرجى التحقق من معلومات الدفع الخاصة بك والمحاولة مرة أخرى.',
      403: 'ليس لديك حق الوصول إلى هذا العنصر أو الصفحة.',
      404: 'لم نتمكن من العثور على ما تبحث عنه.',
      405: 'هذا الإجراء غير مسموح به.',
      408: 'انتهت مهلة طلبك. يرجى المحاولة مرة أخرى.',
      409: 'حدث تعارض مع طلبك. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
      410: 'هذا العنصر لم يعد متاحًا.',
      413: 'الملف الذي قمت بتحميله كبير جدًا.',
      415: 'نوع الملف هذا غير مدعوم.',
      422: 'لم نتمكن من معالجة المعلومات التي قدمتها. يرجى التحقق والمحاولة مرة أخرى.',
      429: 'محاولات كثيرة جدًا. يرجى الانتظار لحظة والمحاولة مرة أخرى.',
      500: 'حدث خطأ ما. يرجى المحاولة مرة أخرى خلال بضع لحظات.',
      502: 'خدمتنا غير متوفرة مؤقتًا. يرجى المحاولة مرة أخرى قريبًا.',
      503: 'نقوم حاليًا بإجراء صيانة. يرجى التحقق مرة أخرى قريبًا.',
      504: 'استغرق طلبك وقتًا طويلاً جدًا للمعالجة. يرجى المحاولة مرة أخرى.',
    },
    ja: {
      400: 'リクエストを処理できませんでした。情報を確認して、もう一度お試しください。',
      401: '購入を続けるにはログインしてください。',
      402: '決済処理に失敗しました。お支払い情報を確認して、もう一度お試しください。',
      403: 'この商品またはページへのアクセス権がありません。',
      404: 'お探しのものが見つかりませんでした。',
      405: 'このアクションは許可されていません。',
      408: 'リクエストがタイムアウトしました。もう一度お試しください。',
      409: 'リクエストに競合がありました。ページを更新してもう一度お試しください。',
      410: 'この商品は利用できなくなりました。',
      413: 'アップロードされたファイルが大きすぎます。',
      415: 'このファイル形式はサポートされていません。',
      422: '提供された情報を処理できませんでした。確認してもう一度お試しください。',
      429: '試行回数が多すぎます。しばらく待ってからもう一度お試しください。',
      500: '問題が発生しました。しばらくしてからもう一度お試しください。',
      502: 'サービスが一時的に利用できません。しばらくしてからもう一度お試しください。',
      503: '現在メンテナンス中です。後ほどもう一度お試しください。',
      504: 'リクエストの処理に時間がかかりすぎました。もう一度お試しください。',
    },
    ko: {
      400: '요청을 처리할 수 없습니다. 정보를 확인하고 다시 시도해 주세요.',
      401: '구매를 계속하려면 로그인하세요.',
      402: '결제 처리에 실패했습니다. 결제 정보를 확인하고 다시 시도해 주세요.',
      403: '이 상품 또는 페이지에 대한 액세스 권한이 없습니다.',
      404: '찾으시는 항목을 찾을 수 없습니다.',
      405: '이 작업은 허용되지 않습니다.',
      408: '요청 시간이 초과되었습니다. 다시 시도해 주세요.',
      409: '요청에 충돌이 있습니다. 페이지를 새로고침하고 다시 시도해 주세요.',
      410: '이 상품은 더 이상 사용할 수 없습니다.',
      413: '업로드한 파일이 너무 큽니다.',
      415: '이 파일 형식은 지원되지 않습니다.',
      422: '제공한 정보를 처리할 수 없습니다. 확인하고 다시 시도해 주세요.',
      429: '시도 횟수가 너무 많습니다. 잠시 후 다시 시도해 주세요.',
      500: '문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
      502: '서비스를 일시적으로 사용할 수 없습니다. 곧 다시 시도해 주세요.',
      503: '현재 유지보수 중입니다. 곧 다시 확인해 주세요.',
      504: '요청 처리 시간이 너무 오래 걸렸습니다. 다시 시도해 주세요.',
    },
    id: {
      400: 'Kami tidak dapat memproses permintaan Anda. Silakan periksa informasi Anda dan coba lagi.',
      401: 'Silakan masuk untuk melanjutkan pembelian Anda.',
      402: 'Pemrosesan pembayaran gagal. Silakan verifikasi informasi pembayaran Anda dan coba lagi.',
      403: 'Anda tidak memiliki akses ke item atau halaman ini.',
      404: 'Kami tidak dapat menemukan yang Anda cari.',
      405: 'Tindakan ini tidak diizinkan.',
      408: 'Permintaan Anda habis waktu. Silakan coba lagi.',
      409: 'Ada konflik dengan permintaan Anda. Silakan muat ulang halaman dan coba lagi.',
      410: 'Item ini tidak lagi tersedia.',
      413: 'File yang Anda unggah terlalu besar.',
      415: 'Jenis file ini tidak didukung.',
      422: 'Kami tidak dapat memproses informasi yang Anda berikan. Silakan periksa dan coba lagi.',
      429: 'Terlalu banyak percobaan. Silakan tunggu sebentar dan coba lagi.',
      500: 'Terjadi kesalahan. Silakan coba lagi dalam beberapa saat.',
      502: 'Layanan kami sementara tidak tersedia. Silakan coba lagi sebentar lagi.',
      503: 'Kami sedang melakukan pemeliharaan. Silakan periksa kembali segera.',
      504: 'Permintaan Anda memakan waktu terlalu lama untuk diproses. Silakan coba lagi.',
    },
    th: {
      400: 'เราไม่สามารถประมวลผลคำขอของคุณได้ โปรดตรวจสอบข้อมูลของคุณแล้วลองอีกครั้ง',
      401: 'โปรดเข้าสู่ระบบเพื่อดำเนินการซื้อต่อ',
      402: 'การประมวลผลการชำระเงินล้มเหลว โปรดตรวจสอบข้อมูลการชำระเงินของคุณแล้วลองอีกครั้ง',
      403: 'คุณไม่มีสิทธิ์เข้าถึงสินค้าหรือหน้านี้',
      404: 'เราไม่พบสิ่งที่คุณกำลังมองหา',
      405: 'การกระทำนี้ไม่ได้รับอนุญาต',
      408: 'คำขอของคุณหมดเวลา โปรดลองอีกครั้ง',
      409: 'มีข้อขัดแย้งกับคำขอของคุณ โปรดรีเฟรชหน้าแล้วลองอีกครั้ง',
      410: 'สินค้านี้ไม่สามารถใช้งานได้อีกต่อไป',
      413: 'ไฟล์ที่คุณอัปโหลดมีขนาดใหญ่เกินไป',
      415: 'ประเภทไฟล์นี้ไม่ได้รับการสนับสนุน',
      422: 'เราไม่สามารถประมวลผลข้อมูลที่คุณระบุได้ โปรดตรวจสอบแล้วลองอีกครั้ง',
      429: 'มีการพยายามมากเกินไป โปรดรอสักครู่แล้วลองอีกครั้ง',
      500: 'เกิดข้อผิดพลาด โปรดลองอีกครั้งในอีกสักครู่',
      502: 'บริการของเราไม่พร้อมใช้งานชั่วคราว โปรดลองอีกครั้งในไม่ช้า',
      503: 'เรากำลังทำการบำรุงรักษา โปรดกลับมาตรวจสอบเร็วๆ นี้',
      504: 'คำขอของคุณใช้เวลานานเกินไปในการประมวลผล โปรดลองอีกครั้ง',
    },
    nl: {
      400: 'We konden uw verzoek niet verwerken. Controleer uw informatie en probeer het opnieuw.',
      401: 'Log in om door te gaan met uw aankoop.',
      402: 'Betalingsverwerking mislukt. Controleer uw betalingsinformatie en probeer het opnieuw.',
      403: 'U heeft geen toegang tot dit artikel of deze pagina.',
      404: 'We konden niet vinden wat u zoekt.',
      405: 'Deze actie is niet toegestaan.',
      408: 'Uw verzoek is verlopen. Probeer het opnieuw.',
      409: 'Er was een conflict met uw verzoek. Vernieuw de pagina en probeer het opnieuw.',
      410: 'Dit artikel is niet meer beschikbaar.',
      413: 'Het bestand dat u heeft geüpload is te groot.',
      415: 'Dit bestandstype wordt niet ondersteund.',
      422: 'We konden de informatie die u heeft verstrekt niet verwerken. Controleer en probeer het opnieuw.',
      429: 'Te veel pogingen. Wacht even en probeer het opnieuw.',
      500: 'Er is iets misgegaan. Probeer het over een paar momenten opnieuw.',
      502: 'Onze service is tijdelijk niet beschikbaar. Probeer het binnenkort opnieuw.',
      503: 'We voeren momenteel onderhoud uit. Kom binnenkort terug.',
      504: 'Uw verzoek duurde te lang om te verwerken. Probeer het opnieuw.',
    },
    it: {
      400: 'Non siamo riusciti a elaborare la tua richiesta. Controlla le tue informazioni e riprova.',
      401: 'Accedi per continuare con il tuo acquisto.',
      402: 'Elaborazione del pagamento non riuscita. Verifica le informazioni di pagamento e riprova.',
      403: 'Non hai accesso a questo articolo o pagina.',
      404: 'Non siamo riusciti a trovare quello che cerchi.',
      405: 'Questa azione non è consentita.',
      408: 'La tua richiesta è scaduta. Riprova.',
      409: "C'è stato un conflitto con la tua richiesta. Aggiorna la pagina e riprova.",
      410: 'Questo articolo non è più disponibile.',
      413: 'Il file che hai caricato è troppo grande.',
      415: 'Questo tipo di file non è supportato.',
      422: 'Non siamo riusciti a elaborare le informazioni che hai fornito. Controlla e riprova.',
      429: 'Troppi tentativi. Attendi un momento e riprova.',
      500: 'Qualcosa è andato storto. Riprova tra qualche istante.',
      502: 'Il nostro servizio è temporaneamente non disponibile. Riprova a breve.',
      503: 'Stiamo attualmente eseguendo la manutenzione. Torna presto.',
      504: 'La tua richiesta ha impiegato troppo tempo per essere elaborata. Riprova.',
    },
  }

export const getHttpStatusMessage = (
  statusCode: number | string,
  language: SupportedLanguage = 'en',
): string | null => {
  const code =
    typeof statusCode === 'string'
      ? Number.parseInt(statusCode, 10)
      : statusCode
  const lang = language.split('-')[0] as SupportedLanguage

  const messages = httpStatusMessages[lang] || httpStatusMessages.en

  return messages[code] || null
}
